import { Typography } from 'antd';
import { ReactNode } from 'react';

/** Card titles are the page's second heading level, under the experience `<h1>` (WCAG 1.3.1). */
export function CardHeading({ children }: { children: ReactNode }) {
  return (
    <Typography.Title
      level={2}
      style={{ fontSize: 'inherit', fontWeight: 'inherit', margin: 0 }}
    >
      {children}
    </Typography.Title>
  );
}
